import React from 'react';
import { Link } from 'react-router-dom';

export const NotFound = () => {

    return (
        <div className="exception-body notfound">
            <img src="/static/assets/layout/images/YZ-02.png" alt="ssyz" className="logo" />

            <div className="exception-content">
                <div className="exception-title">Sayfa Bulunamadı</div>
                <div className="exception-detail">Erişilmek İstenen Sayfa Mevcut Değil.</div>
                <Link to="/">Yönetim Menüsüne Gitmek İçin Tıklayınız</Link>
            </div>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/pages/NotFound.js